export enum PermissionsEnum {
    USER_MANAGEMENT =1,
    PERMISSIONS_MANAGEMENT,
    COMMITTEES_MANAGEMENT ,
    CATEGORIES_MANAGEMENT,
    COMPLAINTS_MANAGEMENT,
    CHOOSE_CATEGORY_COMPLAINT,
	EXTRACT_XLS
}
